const translations = {
    customer: 'Customer',
    onFetchError: 'Error fetching customer data.',
    onGeocodeError: 'Geocoding failed, please correct the address and try again.',
    onGeocodePartialMatch:
        'Your customer was saved but there was a partial match for the address, please review the address.',
    onSaveError: 'An error occurred while saving the customer.',
    onSaveSuccess: 'Customer Saved!',
    save: 'Save'
};

export default translations;
